import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { ResponsiveTable, ResponsiveTableRow, Skeleton } from '@fs/zion-ui'

import { formatProvinceName } from '../../../../utils/text-formatting'

const atSizeColumns = (labels) => {
  return {
    default: {
      labels,
      columnWidths: [6, 6],
    },
  }
}

export default function RecordsTable({
  loading,
  top5 = [],
  countAttribute,
  surname,
  labels = ['Top 5 Provinces', 'Number of Records'],
  withRecordLink,
}) {
  return (
    <>
      {(loading || !top5.length) && <RecordsTableSkeleton labels={labels} />}
      {!loading && (
        <ResponsiveTable verticalAlign="middle" atSizeColumns={atSizeColumns(labels)} totalColumnCount={2}>
          {top5.map((data, index) => (
            <ProvinceStat
              key={data.code}
              count={data[countAttribute]}
              surname={surname}
              displayName={formatProvinceName(data.name)}
              testid={`${countAttribute}-top-${index + 1}`}
              withRecordLink={withRecordLink}
            />
          ))}
        </ResponsiveTable>
      )}
    </>
  )
}

function ProvinceStat({ displayName, count, surname, testid, withRecordLink }) {
  const searchUrl = `/search/discovery/results/?tab=records&q.surname=${surname.replaceAll(' ', '')}&q.surname.exact=on&q.anyPlace=${displayName}%2C%20Philippines&q.anyPlace.exact=on&page=1&results=12`

  return (
    <ResponsiveTableRow
      data-testid={testid}
      to={withRecordLink ? `${baseUrl}${searchUrl}` : undefined}
      linkName={withRecordLink ? `Link:Province Records - ${displayName}:Click` : undefined}
      noBottomDivider
      column1={displayName}
      column2={
        <div style={{ height: '48px', display: 'flex', alignItems: 'center', columnGap: 14 }}>
          {count.toLocaleString()}
        </div>
      }
    />
  )
}

export function RecordsTableSkeleton({ labels = ['Top Provinces', 'Number of Records'] }) {
  return (
    <ResponsiveTable verticalAlign="middle" atSizeColumns={atSizeColumns(labels)} totalColumnCount={2}>
      {Array.from({ length: 5 }).map((_, index) => (
        <ResponsiveTableRow
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          noBottomDivider
          column1={<Skeleton.Paragraph size="md" />}
          column2={<Skeleton.Paragraph size="md" />}
        />
      ))}
    </ResponsiveTable>
  )
}
